export const marketplaceCourierKey = {
  xApiKey: '8833e5cf-0e26-4af0-b99c-a922ae3372f2',
  xApiKeyOrder: 'bfa1bc38-90f7-45c5-8d62-4df2f1aec762'
};
